import {MaterialsQueryKey, MaterialWithRecipesQueryKey} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../../api/mutations'
import {notifyIfErrorMessage} from '../../../../../modules/common/utils/errorHandling'
import type {ErrorResponse} from '../../../../common/types'

import {settingsQueryClient} from '@settings/modules/common/providers'

type deleteGlobalMaterialParams = Parameters<typeof mutations.deleteGlobalMaterial>[0]

export const useDeleteGlobalMaterial = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<void, AxiosError<ErrorResponse>, deleteGlobalMaterialParams>({
    mutationFn: mutations.deleteGlobalMaterial,
    onSuccess: () => {
      notify('success', t('success.editMaterial'))
    },
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSettled: (data, error, variables) => {
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialsQueryKey, variables.plantCode],
        refetchType: 'all'
      })
      void settingsQueryClient.invalidateQueries({
        queryKey: [MaterialWithRecipesQueryKey, variables.plantCode, variables.materialId],
        refetchType: 'all'
      })
    }
  })
}
